var React = require('react');

function LogoWhiteSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFFFFF","fillRule":"evenodd","d":"M5.874 30.63l4.566-8.77 5.62 4.74-10.186 4.03zm19.1-12.888l3.061-4.796 1.68 8.954-4.741-4.158zM16.059 26.6l5.62-4.742 4.566 8.771-10.186-4.03zm0-12.872v11.573l10.805-12.321-5.007-5.055-4.941-4.984-.857-.865V13.73zm5.075 7.085l-5.075 5.787-5.075-5.787-.939-1.07c-.75-.857-1.502-1.713-2.254-2.57l-1.975-2.253-1.733-1.976 3.062 4.797L2.404 21.9l1.679-8.955 5.57-5.622L16.06.857l6.406 6.466 5.57 5.622-2.419 2.76-1.29 1.47-2.252 2.568-.94 1.071z"}));
}

LogoWhiteSmall.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LogoWhiteSmall;

LogoWhiteSmall.default = LogoWhiteSmall;
